import { Link } from 'react-router-dom';
import { editorPick } from '@/mocks/comics';

export default function EditorReview() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="relative rounded-2xl bg-foreground-900 overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-0">
            <div className="lg:col-span-4 relative">
              <div className="h-64 lg:h-full relative overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20professional%20woman%20editor%20portrait%2C%20elegant%20dark%20outfit%2C%20confident%20expression%2C%20clean%20studio%20background%20with%20subtle%20warm%20lighting%2C%20editorial%20photography%20style%2C%20sophisticated%20mood&width=800&height=1000&seq=editor-portrait&orientation=portrait"
                  alt="首席内容主编 金智秀"
                  title="韩漫漫画网 首席内容主编"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-foreground-900/60 lg:bg-gradient-to-r lg:from-transparent lg:to-foreground-900"></div>
              </div>
            </div>

            <div className="lg:col-span-8 relative z-10 px-6 md:px-10 py-8 md:py-12 flex flex-col justify-center">
              <div className="text-primary-400/40 text-8xl font-heading leading-none mb-4 select-none">&ldquo;</div>

              <blockquote className="text-background-50/90 text-base md:text-lg leading-relaxed mb-6">
                {editorPick.content}
              </blockquote>

              <div className="flex items-center gap-4">
                <div>
                  <p className="text-background-50 font-heading font-semibold text-lg">{editorPick.editorName}</p>
                  <p className="text-foreground-400 text-sm">{editorPick.title}</p>
                </div>
              </div>

              <Link
                to="/about"
                className="inline-flex items-center gap-2 mt-8 px-6 py-2.5 rounded-full bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer w-fit whitespace-nowrap"
              >
                了解更多
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}